import dark from './dark';
import light from './light';
import blue from './blue';

export const THEMES = {
  dark,
  light,
  blue,
};
